import { useContext, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
} from "./localStyle";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";

const OtroCentro = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { ordenDigitalDispatch } = useContext(PortalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("Home")(pasoDispatch);
  };
  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"Información centro"}
        subtitle={""}
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              <TurnoNoEncontrado
                state={[]}
                loadingState={loading}
                texto={"ATENCIÓN"}
                recomendacion={
                  "El turno fue tomado correctamente, por favor dirigite al centro correspondiente para comenzar con el proceso de recepcion."
                }
              />
              <ButtonP5 onClick={() => volver()}>Volver al inicio</ButtonP5>
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default OtroCentro;
